export default __webpack_public_path__ + "static/media/wallpaper.9a0dfd4d.jpg";